/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-unknown-property */
import React, { useState, useEffect, useMemo } from 'react';
import GoogleMapReact from 'google-map-react';
import './App.css';
import { LazyLoadingComponent } from '@/../LazyLoading';
import config from '@/configs/config';
import {
  filter, forEach, join, map, size,
} from 'lodash';

const styles = {
  category: {
    display: 'inline-block',
    backgroundColor: 'rgb(229,229,229)',
    color: 'black',
    fontWeight: 'bold',
    padding: '5px 10px',
    margin: 5,
    borderRadius: 5,
    cursor: 'pointer',
  },
  selected: {
    color: 'white',
    backgroundColor: 'black',
  },
  mapContainer: {
    height: 300,
    margin: '0px 0px 10px 0px',
    overflow: 'hidden',
    backgroundColor: 'grey',
  },
  marker: {
    transform: 'translate(-50%,-100%)',
  },
  categoriesContainer: {
    textAlign: 'left',
  },
};

export default function App({ params }) {
  const { data = {} } = params;
  const { categories = [], fridges } = data;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [defaultCenter, setDefaultCenter] = useState({
    lat: 25.047808253750866,
    lng: 121.51720702218408,
  });
  const [selectedFridge, setSelectedFridge] = useState(null);

  const result = useMemo(
    () => (selectedCategory ? filter(fridges, ['district', selectedCategory]) : fridges),
    [selectedCategory, fridges]
  );

  useEffect(() => {
    let lat = 0;
    let lng = 0;

    const length = size(result);

    if (!length) return;

    forEach(result, (fridge) => {
      const { lat: fridgeLat = 0, lng: fridgeLng = 0 } = fridge;

      lat += fridgeLat;
      lng += fridgeLng;
    });

    setDefaultCenter({
      lat: lat / length,
      lng: lng / length,
    });
  }, [result]);

  const renderCategory = (key, name) => (
    <div
      key={key || ''}
      style={{
        ...styles.category,
        ...(key === selectedCategory ? styles.selected : {}),
      }}
      onClick={() => {
        setSelectedCategory(key);
        setSelectedFridge(null);
      }}
    >
      {name}
    </div>
  );

  const renderFridgeElement = (fridge, index) => {
    const {
      address,
      businessHours,
      coverImageUrl,
      googleMapUrl,
      isPublic,
      located,
      name,
    } = fridge;
    const businessHoursArray = [businessHours];

    if (!isPublic) businessHoursArray.push('內部專用不對外開放');

    return (
      (selectedFridge !== null && selectedFridge !== index) ? null : (
        <a className="location-element fz-p-3 fz-flex fz-flex-col fz-basis-1/2 md:fz-basis-1/3 lg:fz-basis-1/4 fz-overflow-hidden" href={googleMapUrl} target="_blank" rel="noopener noreferrer" key={name}>
          <LazyLoadingComponent>
            <img
              src={`${config.RESOURCE_URI}${coverImageUrl}`}
              alt=""
              className="fz-aspect-square"
              onError={(e) => {
                e.currentTarget.src = `${config.RESOURCE_URI}logo.png`;
              }}
            />
          </LazyLoadingComponent>
          <div className="name">{name}</div>
          <div className="address">{`${address} ${located ? `(${located})` : ''}`}</div>
          <div className="description">{join(businessHoursArray, ' | ')}</div>
        </a>
      )
    );
  };

  return (
    <div className="fz-container fz-m-auto">
      <div style={styles.mapContainer} key={defaultCenter ? `${defaultCenter.lat}_${defaultCenter.lng}` : '0'}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: config.googleMapKey }}
          defaultCenter={defaultCenter}
          defaultZoom={13}
        >
          {map(result, (fridge, index) => {
            const {
              lat = 0,
              lng = 0,
              name,
              address,
            } = fridge;
            return (
              <img
                onClick={() => { setSelectedFridge(index); }}
                style={styles.marker}
                alt=""
                src="/images/Location/marker.png"
                key={`${name}${address}`}
                lat={lat}
                lng={lng}
              />
            );
          })}
        </GoogleMapReact>
      </div>
      <div style={styles.categoriesContainer}>
        {renderCategory(null, '全部') }
        {map(categories, (category) => renderCategory(category, category))}
      </div>
      <div className="fz-flex fz-flex-wrap">
        {map(result, renderFridgeElement)}
      </div>
    </div>
  );
}
